import ScalarToggle_vue_vue_type_script_setup_true_lang_default from "./ScalarToggle.vue.script.js";
//#region src/components/ScalarToggle/ScalarToggle.vue
var ScalarToggle_default = ScalarToggle_vue_vue_type_script_setup_true_lang_default;
//#endregion
export { ScalarToggle_default as default };

//# sourceMappingURL=ScalarToggle.vue.js.map